import React from 'react';
import { Button, Input, Col, Row, Container, FormGroup, Label, Form } from 'reactstrap';
import api from '../../api';
import numeral from 'numeral';
import './index.css';

export default class EstimateEBITDATC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            siteId: parseInt(this.props.match.params.location_id, 10) || '',
            expectedEBITDApct: 0.23,
            averageTicketValue: 60125,
            metricsList: [],
            metricsData: {},
        }
    }
    componentDidMount = () => {
        document.title = "Estimate EBITDA - TC model";
        this.getEBITDATCProjection();
    }
    getEBITDATCProjection() {
        const { siteId } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `location/${siteId}/financial_projection_metrics/ebitda_tc_model`,
            success: (response) => {
                console.log('hello', response.metrics_list);
                if (response.result) {
                    this.setState({
                        metricsList: response.metrics_list,
                        metricsData: response.result.data,
                    });
                } else {
                    // alert('Error: ' + response.msg);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    updateExpectedEBITDApct() {
        const { siteId, expectedEBITDApct, averageTicketValue } = this.state;
        const body = {
            expected_ebitda_pct: expectedEBITDApct,
            average_ticket_value: averageTicketValue,
        };
        api.fetchAPI({
            method: 'post',
            body,
            uri: `location/${siteId}/financial_projection_metrics/ebitda_tc_model`,
            success: (response) => {
                if (response.result) {
                    this.setState({
                        metricsList: response.metrics_list,
                        metricsData: response.result.data,
                    });
                } else {
                    // alert('Error: ' + response.msg);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    renderMetrics(metric_code_name, noFormat=false) {
        const { metricsList, metricsData } = this.state;

        const metrics = metricsList.filter(eachMetrics => eachMetrics.code_name === metric_code_name)[0];
        if (!metrics) return;

        let valueToDisplay = metricsData[metrics.code_name]
        if (noFormat) {
            valueToDisplay = metricsData[metrics.code_name];
        } else {
            if (metrics.metrics_type == 'number') {
                valueToDisplay = numeral(metricsData[metrics.code_name]).format('0,0');
            } else if (metrics.metrics_type == 'percentage') {
                valueToDisplay = numeral(metricsData[metrics.code_name]).format('0.00%');
            } else {
                valueToDisplay = metricsData[metrics.code_name];
            }
        }

        return (
            <div className="site-financial-projection-edit__attribute">
                <Label>{metrics.name}</Label>
                <Input
                    disabled
                    value={valueToDisplay}
                    onChange={(e) => this.updateAttr(metrics.code_name, metrics.metrics_type == 'number' || noFormat == false ? e.target.value.replace(/,/g, '') : e.target.value)}
                />
            </div>
        );
    }
    render() {
        const { metricsList, averageTicketValue, expectedEBITDApct, metricsData } = this.state;
        if (!metricsList) return null;
        return (
            <Container>
                <div>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>EBITDA mong muốn</Label>
                                <Input
                                    type="text"
                                    value={expectedEBITDApct}
                                    onChange={(e) => this.setState({ expectedEBITDApct: e.target.value })}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Average Ticket Value</Label>
                                <Input
                                    type="text"
                                    value={averageTicketValue}
                                    onChange={(e) => this.setState({ averageTicketValue: e.target.value })}
                                />
                            </FormGroup>
                            <br />
                            <Button color="success" onClick={() => this.updateExpectedEBITDApct()}>
                                Tính toán
                            </Button>
                        </Col>
                    </Row>
                    <div className="estimate-ebitda-tc__results">
                        <Row className="estimate-ebitda-tc__section">
                            <Col xs={12}>
                                <h3>Kết quả</h3>
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('revenue_to_match_expected_ebitda')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('gross_margin_at_revenue_to_match_expected_ebitda')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('ticket_to_match_expected_ebitda')}
                            </Col>
                        </Row>
                    </div>
                    <div className="estimate-ebitda-tc__results">
                        <Row className="estimate-ebitda-tc__section">
                            <Col xs={12}>
                                <h3>Hòa vốn</h3>
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('break_even_revenue')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('break_even_ticket')}
                            </Col>
                        </Row>
                    </div>
                    <div className="estimate-ebitda-tc__results">
                        <Row className="estimate-ebitda-tc__section">
                            <Col xs={12}>
                                <h3>Chi tiết dự toán</h3>
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('city_average_ticket_value')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('area')}
                            </Col>

                            <Col xs={12} sm={6}>
                                {this.renderMetrics('cogs_value')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('cogs_pct')}
                            </Col>

                            <Col xs={12} sm={6}>
                                {this.renderMetrics('rental_cost_value')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('rental_cost_pct')}
                            </Col>

                            <Col xs={12} sm={6}>
                                {this.renderMetrics('labor_cost_value')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('labor_cost_pct')}
                            </Col>

                            <Col xs={12} sm={6}>
                                {this.renderMetrics('security_cost_value')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('security_cost_pct')}
                            </Col>

                            <Col xs={12} sm={6}>
                                {this.renderMetrics('equipment_cost')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('equipment_pct')}
                            </Col>

                            <Col xs={12} sm={6}>
                                {this.renderMetrics('packaging_consumable_value')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('packaging_consumable_pct')}
                            </Col>

                            <Col xs={12} sm={6}>
                                {this.renderMetrics('other_opex_value')}
                            </Col>
                            <Col xs={12} sm={6}>
                                {this.renderMetrics('other_opex_pct')}
                            </Col>

                            <Col xs={12}>
                                {this.renderMetrics('total_operating_expense')}
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        )
    }
}
